








































































































































import settings from '@/settings'
import Menus from '@/components/menus'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'

export default {
    name: 'company_accounting_software_sync'

    components: { Menus }

    data: ()->
        errors: {}
        as_set: []
        as_link: {
            uid: ''
            accounting_software: {
                uid: ''
                name: ''
            }
            api_url: ''
            api_client_login: ''
            api_client_pw: ''
            api_user_login: ''
            api_user_pw: ''
            intermediary: ''
            comment: ''
            axis: ''
            as_import_item_params_set: []
            user_connection: false
        }
        active_name: 'first'
        vp_code_set: []
        vp_type_set: []
        vp_custom_set: []
        new_code: {
            uid: ''
            value: ''
        }
        new_type: {
            uid: ''
            name: ''
        }
        code_creation_explanation: "Création d'un code : écrire le code puis le sélectionner dans la liste déroulante en cliquant dessus."
        api_loading: false
        api_count: 0
        api_ok: false
        api_errors: ''
        dialog_visible: false

    methods:
        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        close_dialog: ()->
            if !@api_loading
                @dialog_visible = false
            return

        click_import: (slug)->
            self = @
            @dialog_visible = true
            @request_errors = ''
            @api_loading = true
            @$http.post(settings.accounting_software_import, {"company_uid":@$store.getters.current_company.uid, "item":slug})
            .then (resp)->
                # console.log "CLICK IMPORT resp", resp
                self.api_loading = false
                self.api_ok = resp.body.status
                self.api_count = resp.body.import_count
                self.api_errors = resp.body.errors
                self.get_accounting_software_company_link(false)
            .catch (error)->
                self.api_ok = false
                self.api_count = 0
                self.api_errors = ''
                self.api_loading = false
                n.catch_error(error, "company_accounting_software_sync: click_import()")
            return

        get_as_set: ()->
            self = @
            q.run('get_accounting_software_set', [])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_accounting_software_sync: get_as_set: then", e.message)
                else
                    # console.log "GET AS SET : ", resp.body.data.accounting_software_set
                    if resp.body.data.accounting_software_set != null
                        self.as_set = resp.body.data.accounting_software_set
                        self.get_accounting_software_company_link(true)
            .catch (resp)->
                n.catch_error(resp, "company_accounting_software_sync: get_as_set()")

        get_vp_code_set: ()->
            self = @
            q.run('get_vp_code_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_accounting_software_sync: get_vp_code_set: then", e.message)
                else
                    # console.log "GET_VP_CODE_SET : ", resp.body.data.vp_code_set
                    if resp.body.data.vp_code_set != null
                        self.vp_code_set = resp.body.data.vp_code_set
            .catch (resp)->
                n.catch_error(resp, "company_accounting_software_sync: get_vp_code_set()")

        get_vp_type_set: ()->
            self = @
            q.run('get_vp_type_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_accounting_software_sync: get_vp_type_set: then", e.message)
                else
                    # console.log "GET_VP_TYPE_SET : ", resp.body.data.vp_type_set
                    if resp.body.data.vp_type_set != null
                        self.vp_type_set = resp.body.data.vp_type_set
            .catch (resp)->
                n.catch_error(resp, "company_accounting_software_sync: get_vp_type_set()")

        get_vpc_set: ()->
            self = @
            q.run('get_vpc_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_accounting_software_sync: get_vpc_set: then", e.message)
                else
                    # console.log "GET_VPC_SET : ", resp.body.data.variable_payroll_custom_set
                    if resp.body.data.variable_payroll_custom_set != null
                        self.vp_custom_set = resp.body.data.variable_payroll_custom_set
                        self.get_vp_type_set()
                        self.get_vp_code_set()
                        for item in self.vp_custom_set
                            if item.vp_code is null
                                item.vp_code = t.deep_copy(self.new_code)
                            if item.vp_type is null
                                item.vp_type = t.deep_copy(self.new_type)
            .catch (resp)->
                n.catch_error(resp, "company_accounting_software_sync: get_vpc_set()")

        get_accounting_software_company_link: (vpc)->
            self = @
            q.run('get_accounting_software_company_link', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_accounting_software_sync: get_accounting_software_company_link: then", e.message)
                else
                    # console.log "GET ACCOUNTING_SOFTWARE_COMPANY_LINK : ", resp.body.data.accounting_software_company_link
                    if resp.body.data.accounting_software_company_link != null
                        self.as_link = resp.body.data.accounting_software_company_link
                        if vpc
                            self.get_vpc_set()
            .catch (resp)->
                n.catch_error(resp, "company_accounting_software_sync: get_accounting_software_company_link()")

        save_parameters: ()->
            # console.log "SAVE PARAMETERS", @vp_custom_set
            for vpc in @vp_custom_set
                if vpc.vp_type.uid == ''
                    n.file_error('Erreur', 'Un type est requis')
                    return
            vpc_set = @vp_custom_set.map (x)->
                {
                    "uid":x.uid,
                    "vp_code_uid_or_new":x.vp_code.uid,
                    "vp_type_uid":x.vp_type.uid,
                }
            # console.log "SAVE PARAMETERS", vpc_set
            self = @
            m.run('save_vp_custom_type_code', [vpc_set, @$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.data.vp_custom_type_code_mutation.ok
                    n.success()
                    self.get_vpc_set()
                else
                    n.error("company_accounting_software_sync: save_parameters()", resp.body.data.vp_custom_type_code_mutation.message)
            .catch (resp)->
                n.catch_error(resp, "company_accounting_software_sync: save_parameters()")

        save_connection: ()->
            # console.log "SAVE CONNECTION", @as_link
            if @as_link.accounting_software.uid == ''
                n.file_error('Erreur', 'Un nom de logiciel de paie est requis')
                return
            @as_link.company_uid = @$store.getters.current_company.uid
            @as_link.automatic_item_uid_set = @as_link.as_import_item_params_set
            .filter (x)->
                return x.automatic
            .map (x)->
                return x.uid
            # console.log "AUTOMATIC_ITEM_UID_SET", @as_link.automatic_item_uid_set
            self = @
            m.run('save_accounting_software_company_link', [@as_link])
            .then (resp)->
                if resp.body.data.accounting_software_company_link_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.accounting_software_company_link_form_mutation.errors.length > 0
                    self.errors = resp.body.data.accounting_software_company_link_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    self.get_accounting_software_company_link(true)
                    n.success()
            .catch (resp)->
                n.catch_error(resp, "company_accounting_software_sync: save_connection()")

    beforeMount: ()->
        # console.log "beforeMount company_accounting_software_sync"
        @get_as_set()
}
